angular
  .module("calcoloIrapAra.components", [])
  .component("calcoloIrapAra", {
    templateUrl: "ng/components/calcoloIrap/calcoloIrapAra.view.html",
    bindings: {},
    controllerAs: "calcoloIrapAraCtrl",
    controller: function CalcoloIrapAra(
      $location,
      $arcService,
      $modalService,
      $transactionFactory,
      $searchUserService,
      $financialApiService,
      RichiestePostVendita
    ) {
      var self = this;
      self.$onInit = function () {
        self.ctrRichiestaList = [];

        self.filterAllContracts = {
          appContract: {
            limit: "10",
            offset: 0,
            pageIndex: 1,
            totalPages: 0,
            annoRiferimentoIrap: null
          }
        }
      }

      self.getContractList = function (filter) {
        self.isPending = true;
        self.searchStarted = true;
        if (!filter) {
          filter = self.filterAllContracts.appContract;
        }
        $arcService
          .getIrap(filter)
          .then(function (response) {
            self.isPending = false;
            self.metadata = response;
            if (self.metadata.success) {
              var totalCount = response.totaleContratti;
              self.filterAllContracts.appContract.totalPages = Math.ceil(
                response.totaleContratti / 10
              );
              if (self.metadata.listContratti == 0) {
                self.nothingToShow = true;
              }
              else {
                self.nothingToShow = false;
              }
              getSTotalPages(totalCount);
            } else if (!self.metadata.success) {
              self.nothingToShow = true;
            }
          }).catch(function (error) {
            console.log(error);
            self.isPending = false;
            self.nothingToShow = true;
          });
      }
      self.openDettagliCalcolo = function (contratto) {
        $transactionFactory.set(contratto);
        $location.path("/dettagliCalcolo");
      }

      self.onPressSearch = function (filter) {
        self.isPending = true;
        self.filterAllContracts.appContract = filter;
        Object.assign(self.filterAllContracts.appContract, {
          limit: "10",
          offset: 0,
          pageIndex: 1,
          totalPages: 0
        })
        self.getContractList(filter);
      }

      self.openDettaglioCruscotto = function (id) {
        //self.loaderDettaglioPv[index] = true;

        $financialApiService.dettaglioRichiestaPv(id)
          .then(function (response) {
            //self.loaderDettaglioPv[index] = false;
            response.readOnly = true;
            var richiestePostVenditaModel = RichiestePostVendita.build(response);
            $transactionFactory.set(richiestePostVenditaModel);
            $location.path('/dettaglioCruscottoRichiestaClienti')
          })
          .catch(function () {
            //self.loaderDettaglioPv[index] = false;
          })
      }

      self.pageSIndexIndietro = function (value) {
        self.isPending = true;
        if (value == "init") {
          self.filterAllContracts.appContract.pageIndex = 1;
        } else {
          if (self.filterAllContracts.appContract.pageIndex > 1) {
            self.filterAllContracts.appContract.pageIndex--;
          }
        }
        updateOffsetAndSearch();
      };

      self.pageSIndexAvanti = function (value) {
        self.isPending = true;
        if (value == "end") {
          //subito pagina finale
          self.filterAllContracts.appContract.pageIndex =
            self.filterAllContracts.appContract.totalPages;
        } else {
          //avanzo +1
          if (
            self.filterAllContracts.appContract.pageIndex <
            self.filterAllContracts.appContract.totalPages
          ) {
            self.filterAllContracts.appContract.pageIndex++;
          }
        }
        updateOffsetAndSearch();
      };
      function updateOffsetAndSearch() {
        self.filterAllContracts.appContract.offset =
          (self.filterAllContracts.appContract.pageIndex - 1) *
          self.filterAllContracts.appContract.limit;

        self.getContractList(self.filterAllContracts.appContract);
      }

      function getSTotalPages(totalCount) {
        //se il resto Ã¨ zero non va aggiunto +1
        var addPlusOneToTotal = 0;
        var totModuloResult =
          totalCount % Number(self.filterAllContracts.appContract.limit);
        if (totModuloResult > 0) {
          addPlusOneToTotal = 1;
        }
        return (
          Math.floor(
            totalCount / Number(self.filterAllContracts.appContract.limit)
          ) + addPlusOneToTotal
        );
      }
    }
  }); 